// src/components/admin/design/BestSellersPreview.tsx
"use client";

import UniversalProductCardPreview from "./UniversalProductCardPreview";

export interface BestSellersPreviewProps {
  variantId: string;
  primaryColor?: string;
  theme?: "dark" | "light";
  subdomain?: string;
}

export default function BestSellersPreview({
  variantId = "motion_3d",
  primaryColor = "#059669",
  theme,
  subdomain,
}: BestSellersPreviewProps) {
  return (
    <UniversalProductCardPreview
      sectionTitle="Best Sellers"
      variantId={variantId}
      primaryColor={primaryColor}
      theme={theme}
      subdomain={subdomain}
    />
  );
}